module.exports = __webpack_public_path__ + "assets/best-2d39072d6f033811b7cf888aa95e8681.svg";